import { firstToUpper } from "./string";

export const renderHourType = (hourType) => {
	if (hourType === "pto") {
		return "PTO";
	}
	return hourType
		? firstToUpper(hourType.replaceAll("-", " ").toLowerCase())
		: "";
};

export const getHourTypeColor = (hourType) => {
	switch (hourType) {
		case "unit":
			return "hsl(var(--muted-foreground))";
		case "regular":
			return "hsl(var(--primary))";
		case "override":
			return "hsl(var(--chart-1))";
		case "amount":
			return "hsl(var(--chart-5))";
		case "overtime":
			return "hsl(var(--chart-3))";
		case "double-time":
			return "hsl(var(--destructive))";
		case "double-time-and-half":
			return "hsl(var(--chart-4))";
		case "pto":
			return "hsl(var(--chart-2))";
		case "unpaid":
			return "hsl(var(--muted))";
		case "holiday":
			return "hsl(var(--secondary-foreground))";
		case "retro":
			return "hsl(var(--accent-foreground))";
		default:
			return "hsl(var(--foreground))";
	}
};

export const getShortHourType = (hourType) => {
	switch (hourType) {
		case "double-time":
			return "dt";
		case "double-time-and-half":
			return "dth";
		case "regular":
		case "override":
			return "reg";
		case "unit":
			return "unit";
		case "overtime":
			return "ot";
		case "pto":
			return "pto";
		case "holiday":
			return "hol";
		default:
			return firstToUpper(hourType.split("-").join(" "));
	}
};
